<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">

      <el-form :inline="true" :model="informdata" class="demo-form-inline">
        <el-form-item label="备注">
          <el-input v-model="informdata.cremaks" placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="informdata.cvensubmit" placeholder="请选择">
            <el-option label="等待提报" value="等待提报"></el-option>
            <el-option label="已提报" value="已提报"></el-option>
            <el-option label="全部数据" value="全部数据"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetInquiryList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border style="width: 100%;" max-height="560" class="tb-edit" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="单号" prop="ccode" min-width="110"></el-table-column>
        <el-table-column label="工厂" prop="cfactory" width="160"></el-table-column>
        <el-table-column label="提报状态" prop="cvensubmit" width="110"></el-table-column>

        <el-table-column prop="dstockdate" label="库存截止日期" width="160"></el-table-column>
        <el-table-column prop="dstopdate" label="提报截止日期" width="160"></el-table-column>
        <!-- <el-table-column prop="dstopdate" label="提报截止日期" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.dstopdate">{{scope.row.dstopdate.substring(0,10)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="dsubmitdate" label="下发通知日期" width="110"></el-table-column>
        <el-table-column prop="dvensubmitdate" label="实际提报日期" width="110"> </el-table-column>
        <el-table-column prop="cremaks" label="备注" min-width="160"></el-table-column>
        <el-table-column prop="cvennote" label="提报备注" min-width="160"></el-table-column>

        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
      <div style="clear:both"></div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      informdata: {
        // 询价单号
        cremaks: "",
        cvensubmit: "等待提报",
      },
      tableData: [],
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.GetInquiryList();
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInquiryList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInquiryList();
    },
    // 获取信息
    GetInquiryList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/SubmitStockList",
        data: {
          csubmit: this.informdata.cvensubmit,
          cremaks: this.informdata.cremaks,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        this.loading = false;
        if (res.data.Success) {
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.recordCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    supedit(row) {
      this.$router.push({
        name: "Factorypricing",
        params: { rows: row, informdata: this.informdatanew },
      });
    },
  },
};
</script>